import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ user, roles, children }) => {
    if (!user) {
        return <Navigate to="/" replace />;
    }

    if (roles && roles.length > 0 && !roles.includes(user.role)) {
        // User not authorized, redirect to dashboard or show unauthorized page
        // For simplicity redirect to dashboard which everyone has access to
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
